export const cellLabelSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  fontSize: 14,
  color: 'text.secondary',
  mb: 0.5,
} as const;

export const cellValueSx = {
  fontSize: 16,
  lineHeight: 1.5,
  color: 'text.primary',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const;

export const cellSubSx = {
  fontSize: 14,
  color: 'text.secondary',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
} as const;
